import { render, staticRenderFns } from "./HandleGroupRemittanceNotification.vue?vue&type=template&id=15f05aba&scoped=true"
import script from "./HandleGroupRemittanceNotification.vue?vue&type=script&lang=js"
export * from "./HandleGroupRemittanceNotification.vue?vue&type=script&lang=js"
import style0 from "./HandleGroupRemittanceNotification.vue?vue&type=style&index=0&id=15f05aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f05aba",
  null
  
)

export default component.exports